import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, Input, HostListener } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: "app-category",
    templateUrl: "./category.component.html",
    styleUrls: ["./category.component.css"]
})
export class BlogCategoryComponent implements OnInit, OnDestroy {
    blogPost: Observable<any[]>;
    categories: Observable<any[]>;
    categoryName: string;

    constructor(private afs: AngularFirestore,
        private activatedRoute: ActivatedRoute) {

    }
    async ngOnInit() {
       await this.activatedRoute.params.subscribe(data => {
            this.blogPost =this.afs.collection('blog', ref => ref.where('uniqueName', '==', data.uniqueName).orderBy('modifyDate')).snapshotChanges().pipe(map(actions => {
                return actions.map(a => {
                    return {
                        id: a.payload.doc.id,
                        ...a.payload.doc.data()
                        
                    }
                });
            }));
     


        });
        this.categories = await this.afs.collection('blogCategories').valueChanges();
       
       

    }
    ngOnDestroy() { }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/blog-page/category/category.component.ts